import React, { useState } from "react";
import styled from "styled-components";

import typography from "../../theme/typography";

import TrashImage1 from "../../assets/trash/trash-01.png";
import TrashImage2 from "../../assets/trash/trash-02.png";
import TrashImage3 from "../../assets/trash/trash-03.png";
import TrashImage4 from "../../assets/trash/trash-04.png";
import TrashImage5 from "../../assets/trash/trash-05.png";
import TrashImage6 from "../../assets/trash/trash-06.png";
import TrashImage7 from "../../assets/trash/trash-07.png";

import ImageButton from "../shared/ImageButton";

const Page = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.color.black};
  height: 100%;
`;

const Background = styled.img`
  margin-bottom: 49px;
`;

const PlaceHolder = styled.div`
  width: 360px;
  height: 420px;
`;

const Text = styled.p`
  position: relative;
  width: 100%;
  height: 100px;
  text-align: center;
  color: ${(props) => props.theme.color.white};
  ${typography.mainText1};
  margin-bottom: 51px;
`;

const Selection = styled.div`
  display: flex;
  gap: 30px;
`;

const Trash = styled.img`
  position: absolute;
  bottom: 350px;
  right: 20px;
`;

const GameSelectionLayout = ({
  bg,
  imageA,
  textA,
  onClickA,
  imageB,
  textB,
  onClickB,
  currentIndex,
  children,
}) => {
  const [loading, setLoading] = useState(true);

  const trashImages = [
    TrashImage1,
    TrashImage2,
    TrashImage3,
    TrashImage4,
    TrashImage5,
    TrashImage6,
    TrashImage7,
  ];
  const trashImage = trashImages[currentIndex];

  return (
    <Page>
      {loading && <PlaceHolder />}
      <Background src={bg} alt="" onLoad={() => setLoading(false)} />

      <Text>{children}</Text>

      <Selection>
        <ImageButton img={imageA} text={textA} onClick={onClickA} />
        <ImageButton img={imageB} text={textB} onClick={onClickB} />
      </Selection>

      <Trash src={trashImage} />
    </Page>
  );
};

export default GameSelectionLayout;
